export const publicSitePaths = Object.freeze([
    "/",
    "/news",
    "/contacts",
]);

export const guestPublicHeaderPaths = Object.freeze([
    "/login",
    "/register",
    "/reset",
    "/terms-of-use",
    "/privacy-page",
    "/service",
]);

export function isGuestPublicHeaderPath(pathname) {
    return guestPublicHeaderPaths.some((publicPath) => (
        pathname === publicPath ||
        pathname.startsWith(`${publicPath}/`)
    ));
}

export function isPublicSitePath(pathname) {
    return publicSitePaths.some((publicPath) => {
        if (publicPath === "/") {
            return pathname === publicPath;
        }

        return (
            pathname === publicPath ||
            pathname.startsWith(`${publicPath}/`)
        );
    });
}

export function isPlatformNewsPath(pathname) {
    return (
        pathname === "/news" ||
        pathname.startsWith("/news/")
    );
}

export function getLandingSectionHref(pathname, sectionId) {
    return pathname === "/"
        ? `#${sectionId}`
        : `/#${sectionId}`;
}
